import Image from 'react-bootstrap/Image';
import { GOOGLE_STORAGE_API, STATIC_BUCKET } from '../../common';

/** Sous composant pour l'affichage de la vidéo floutée
 *
 * @param {*} videoUrl: url absolue de la vidéo
 * @returns
 */
function VideoBlurred({ videoUrl }) {
    return (
        <>
            <div style={{
                filter: 'blur(12px)',
                position: 'absolute',
                inset: '0',
                width: '100%',
                height: '100%',
                zIndex: '-1000',
                overflow: 'hidden', // Important pour cacher les débordements potentiels du flou
            }}>
                <video
                    src={videoUrl}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover', // Assure que la vidéo remplit l'espace sans distorsion
                    }}
                />
            </div>
        </>
    );
}

/** Sous composant pour l'affichage de l'image floutée
 * 
 * @param {*} image: url absolue de l'image
 * @returns 
 */
function ImageBlurred({ image }) {
    return (
        <>
            <div style={{
                filter: 'blur(12px)',
                position: 'absolute',
                inset: '0',
                width: '100%',
                height: '100%',
                'backgroundImage': 'url(' + image + ')',
                'backgroundPosition': 'center',
                'OBackgroundSize': 'cover',
                'MozBackgroundSize': 'cover',
                'WebkitBackgroundSize': 'cover',
                'backgroundSize': '98% 98%',
                'backgroundRepeat': 'no-repeat',
                'zIndex': '-1000',
            }}></div>
        </>
    )
}
/** Affichage d'une image avec un background flout
 * 
 * @param {*} interaction: l'interaction
 * @returns 
 */
function ImageBackground({
    interaction,
    isImageBlur
}) {
    return (
        <>
            {interaction.background_url && interaction.background_url.includes(GOOGLE_STORAGE_API) && !interaction.background_url.includes(STATIC_BUCKET) ? (
                <div class="conteneur-video-accueil">
                    {isImageBlur && (
                        <VideoBlurred videoUrl={interaction.background_url} />
                    )}
                    <div class="video-accueil">
                        <video src={interaction.background_url} controls autoPlay loop muted playsInline width="300" />
                    </div>
                </div>
            ) : (
                <>
                    <div class="conteneur-image-accueil">
                        {isImageBlur &&
                            <>
                                <ImageBlurred image={interaction.background_url || interaction.background_url_default} />
                            </>
                        }
                        <div class="image-accueil">
                            <Image src={interaction.background_url !== null ? interaction.background_url.split('?')[0] : interaction.background_url_default.split('?')[0]} fluid />
                        </div>
                    </div>
                </>
            )
            }
        </>
    )
};
export default ImageBackground;